import React from 'react';
import ModalSkeleton from '../ModalSkeleton';
import classes from './ProjectsMoreFiltersModal.module.css';
import { Col, Row } from 'react-bootstrap';
import Button from '../../Component/Button/Button';

const ProjectsMoreFiltersModal = ({
  show,
  setShow,
  t,
  // onClick, isLoading,
  children,
  onApply
}) => {
  return (
    <ModalSkeleton
      width={'600px'}
      show={show}
      setShow={setShow}
      header={t('filters.filter')}
      headerClass={classes.headerClass_headerClass}
      modalClass={classes.modal}>
      <Row className={classes.row}>
        {children}
        <Col md={12}>
          <Button
            className={classes.btn}
            onClick={() => {
              onApply?.();
              setShow(false);
            }}>
            {t('projectModal.apply')}
          </Button>
        </Col>
      </Row>
    </ModalSkeleton>
  );
};

export default ProjectsMoreFiltersModal;
